import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useTema, type Tema } from "./theme-provider";

const SIGUIENTE: Record<Tema, Tema> = { light: "dark", dark: "light" };

const ETIQUETA: Record<Tema, string> = {
  light: "Tema claro (clic para oscuro)",
  dark: "Tema oscuro (clic para claro)",
};

export function ThemeToggle(): JSX.Element {
  const { tema, setTema } = useTema();
  const Icono = tema === "light" ? Sun : Moon;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => setTema(SIGUIENTE[tema])}
          aria-label={ETIQUETA[tema]}
        >
          <Icono className="h-4 w-4" aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{ETIQUETA[tema]}</TooltipContent>
    </Tooltip>
  );
}
